import { render, staticRenderFns } from "./DriveUploaderSubmit.vue?vue&type=template&id=9c442a9e&lang=pug"
import script from "./DriveUploaderSubmit.vue?vue&type=script&lang=ts"
export * from "./DriveUploaderSubmit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports